import ServerApi from './$server.api'

export default {
    createRefund,
    getRefunds,
    deleteRefund
}

async function createRefund(data) {
    return await ServerApi.request('post', '/refunds', {data})
}

async function getRefunds(query) {
    return await ServerApi.request('get', '/refunds', {query})
}

async function deleteRefund(refundId) {
    return await ServerApi.request('delete', `/refunds/${ refundId }`)
}